import { captureException } from '@sentry/react';

import type { MessageEventPayload } from '../../types/message';
import type { Provider } from '../../types/provider';
import { isOriginAllowed } from '../functions/allowedOrigins';

export default class MessageDispatcherService {
  private readonly targetOrigin: string;

  constructor(targetOrigin: string | null) {
    this.targetOrigin = targetOrigin ?? '';
  }

  private sendMessage(message: MessageEventPayload) {
    if (!isOriginAllowed(this.targetOrigin)) {
      captureException(
        new Error(
          `Blocked postMessage to disallowed origin: ${this.targetOrigin}`,
        ),
      );

      return;
    }

    window.parent?.postMessage(message, this.targetOrigin);
  }

  sendTokensMessage(tokens: Record<string, string>) {
    this.sendMessage({ type: 'TOKENS', payload: { tokens } });
  }

  sendFederatedSignInMessage({ provider }: { provider: Provider }) {
    this.sendMessage({ type: 'FEDERATED_SIGN_IN', payload: { provider } });
  }

  sendRouteChangeMessage({ page, search }: { page: string; search: string }) {
    this.sendMessage({ type: 'ROUTE_CHANGE', payload: { page, search } });
  }
}
